import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'note-icon',
  templateUrl: './note-icon.component.html',
  styles: [':host { line-height: 0; }'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class NoteIconComponent {}
